// Canonical client-type taxonomy emitted by the CSV ingest lambda's
// `deriveFacets` (`packages/lambdas/src/sqs/advisors-csv-ingest/facets.ts`).
// These strings match what is stored in `RiaFirm.clientTypes` in Postgres.
export const ALL_CLIENT_TYPES = [
  'Individuals',
  'High-Net-Worth Individuals',
  'Banking / Thrift Institutions',
  'Investment Companies',
  'Business Development Companies',
  'Pension / Profit-Sharing Plans',
  'Charitable Organizations',
  'State/Municipal Entities',
  'Other Investment Advisers',
  'Insurance Companies',
  'Sovereign Wealth Funds',
  'Corporations / Other Businesses',
  'Other',
] as const;

export type ClientType = (typeof ALL_CLIENT_TYPES)[number];
